/** @file Makes a skin the document's default skin. */
import { z } from 'zod';
import { defineCommand } from '../defineCommand';

/** skin.setDefault: points defaultSkin at the skin; the current default is a no-op (W2-31). */
export const command = defineCommand({
  name: 'skin.setDefault',
  description: 'Make a skin (name or id) the default skin: the one renders and exports use when none is named.',
  input: z.object({ target: z.string().min(1) }).strict(),
  apply(draft, input, ctx) {
    const id = ctx.resolve('skin', input.target);
    if (id === draft.defaultSkin) return;
    draft.defaultSkin = id;
    draft.meta.updatedAt = ctx.now;
  },
});
